import { render, staticRenderFns } from "./pageLayout.vue?vue&type=template&id=01554dd0&scoped=true&"
import script from "./pageLayout.vue?vue&type=script&lang=js&"
export * from "./pageLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01554dd0",
  null
  
)

export default component.exports